var map = {
	"./account.svg": 1185,
	"./account_badged.svg": 1188,
	"./account_checked.svg": 1189,
	"./alert-circle.svg": 1190,
	"./arrow-left_rounded.svg": 1191,
	"./arrow-left_squared.svg": 1192,
	"./arrow-right_rounded.svg": 1193,
	"./arrow-right_squared.svg": 1194,
	"./arrow-top.svg": 1195,
	"./bank-check.svg": 1196,
	"./bell-checkmark.svg": 1197,
	"./bell-plus.svg": 1198,
	"./bell.svg": 1199,
	"./bookmark.svg": 1200,
	"./bookmark_filled.svg": 1201,
	"./bullet-leaf.svg": 1202,
	"./calendar.svg": 1203,
	"./cart-checkmark.svg": 1204,
	"./cart-clock.svg": 1205,
	"./cart-plus.svg": 1206,
	"./cart.svg": 1207,
	"./cart_added.svg": 1208,
	"./cart_deleted.svg": 1209,
	"./cart_emptied.svg": 1210,
	"./chat.svg": 1211,
	"./checkmark-white.svg": 1212,
	"./checkmark.svg": 1213,
	"./chevron-down.svg": 1214,
	"./chevron-left.svg": 1215,
	"./chevron-right.svg": 1216,
	"./chevron-up.svg": 1217,
	"./clock.svg": 1218,
	"./close.svg": 1219,
	"./copy.svg": 1220,
	"./cost.svg": 1221,
	"./cream.svg": 1222,
	"./credit-card.svg": 1223,
	"./delete.svg": 1224,
	"./delivery.svg": 1225,
	"./download.svg": 1226,
	"./edit.svg": 1227,
	"./erase.svg": 1228,
	"./error-circle.svg": 1229,
	"./file-pdf.svg": 1230,
	"./filter.svg": 1231,
	"./gift.svg": 1232,
	"./heart.svg": 1233,
	"./heart_filled.svg": 1234,
	"./hide.svg": 1235,
	"./history.svg": 1236,
	"./hourglass.svg": 1237,
	"./info-circle.svg": 1238,
	"./invoice.svg": 1239,
	"./link.svg": 1240,
	"./lock.svg": 1241,
	"./log-in.svg": 1242,
	"./log-out.svg": 1243,
	"./menu.svg": 1244,
	"./microscope.svg": 1245,
	"./minus.svg": 1246,
	"./mortar.svg": 1247,
	"./offers.svg": 1248,
	"./package.svg": 1249,
	"./package_returned.svg": 1250,
	"./payment-4x.svg": 1251,
	"./payments.svg": 1252,
	"./place_added.svg": 1253,
	"./play-overlay.svg": 1254,
	"./play.svg": 1255,
	"./plus.svg": 1256,
	"./question-circle.svg": 1257,
	"./rebuy.svg": 1258,
	"./recipe-book.svg": 1259,
	"./search.svg": 1260,
	"./share.svg": 1261,
	"./shop.svg": 1262,
	"./show.svg": 1263,
	"./star.svg": 1264,
	"./star_filled.svg": 1265,
	"./survey-logo.svg": 1266,
	"./time.svg": 1267,
	"./transfer.svg": 1268,
	"./unsub.svg": 1269,
	"./warning.svg": 1270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1184;